const namespace = 'binder/';

export const REQUEST_INITIAL_BINDER_DATA = `${namespace}REQUEST_INITIAL_BINDER_DATA`;
export const STORE_BINDER_IMPERSONATED_USER = `${namespace}STORE_BINDER_IMPERSONATED_USER`;
export const SET_ENABLED_FILTERS = `${namespace}SET_ENABLED_FILTERS`;
export const UNLOAD_BINDER_DATA = `${namespace}UNLOAD_BINDER_DATA`;

